import { Injectable } from '@angular/core';
import { HhsgSharedStuderEmployee } from '../../models/sgportal-data-api-models/employee.model';
import { HhsgSharedStuderJobTitle } from '../../models/sgportal-data-api-models/job-title.model';
import { HhsgSharedConfigService } from '../config.service';
import { HhsgSharedHttpService } from '../http.service';

@Injectable()
export class HhsgSharedStuderJobTitleService {
	private readonly _controllerName: string = 'JobTitle';
    private readonly _sgPortalApiServer: string;

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._sgPortalApiServer = _configService.appSettings.sgPortalApiServer;
    }

	public async getJobTitlesWithEmployeeAndDeptCount(organizationId: number): Promise<HhsgSharedStuderJobTitle[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderJobTitle[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetJobTitlesWithEmployeeAndDeptCount/${organizationId}`);
	}
	
	public async getJobTitleByOrganizationAndDept(organizationId: number, departmentId: number): Promise<HhsgSharedStuderJobTitle[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderJobTitle[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetJobTitleByOrganizationAndDept/${organizationId}/${departmentId}`);
	}

	public async getJobTitle(jobTitleId: number, organizationId: number): Promise<HhsgSharedStuderJobTitle> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderJobTitle>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetJobTitle/${jobTitleId}/${organizationId}`);	
	}

	public saveJobTitle(jobTitleModel: HhsgSharedStuderJobTitle): Promise<string> {
		return this._httpService.doPostRequestAsync<any, string>(this._sgPortalApiServer, this._controllerName, 'SaveJobTitle', jobTitleModel);
	}

	public async deleteJobTitle(jobTitleModel: HhsgSharedStuderJobTitle): Promise<void> {
		return this._httpService.doPostRequestAsync<any, void>(this._sgPortalApiServer, this._controllerName, 'DeleteJobTitle', jobTitleModel);
	}

	public async disassociateJobTitleFromDepartment(jobTitleId: number): Promise<void> {
		return this._httpService.doGetRequestAsync<void>(this._sgPortalApiServer, this._controllerName, `DisassociateJobTitleFromDepartment/${jobTitleId}`);	
	}

	public async getEmployeeDeptAndDivByJobTitle(jobTitleId: number, organizationId: number): Promise<HhsgSharedStuderEmployee[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderEmployee[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetEmployeeDeptAndDivByJobTitle/${jobTitleId}/${organizationId}`);	
	}

	public async getJobTitlesForOrganization(organizationId: number): Promise<HhsgSharedStuderJobTitle[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderJobTitle[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetJobTitlesForOrganization/${organizationId}`);	
	}
}
